import Helmet from 'react-helmet';
import {useIntl} from 'react-intl';
import {useLocation} from 'react-router';
import classNames from 'classnames';
import {useSelector} from 'react-redux';
import InfoArticle from '@components/shared/InfoArticle/InfoArticle';
import {useCurrentRoute} from '@hooks/useCurrentRoute';
import {
    DASHBOARD_PATH,
    LOGIN_PATH,
    PASSWORD_RECOVERY_PATH,
    DESIGNER_PATH,
    PASSWORD_RESET_PATH,
    REGISTRATION_PATH,
    ACCOUNT_REGISTRATION_PATH,
    ERROR_PATH,
    FAST_TRACK_PATH,
    VS_FEATURES,
    CONNECT_AUTHORIZE_PATH
} from '@constants';
import {selectLocale} from '@components/appSlice';
import useAccessRestrictions from '@hooks/useAccessRestrictions';
import GDPRBunner from '../GDPRBunner/GDPRBunner';
import HeaderV2 from '../HeaderV2/HeaderV2';
import SignerUiHeader from '../SignerUiHeader/SignerUiHeader';
import SignerUiMenu from '../SignerUiHeader/SignerUiMenu/SignerUiMenu';
import VSFeature, {Enabled} from '../../shared/VSFeature/VSFeature';
import FloatingActions from '../../shared/FloatingActions/FloatingActions';
import './layoutV2.less';

export function LayoutV2({children}) {
    const intl = useIntl();
    const location = useLocation();
    const locale = useSelector(selectLocale);
    const {hideHeader} = useAccessRestrictions();
    const currentRoute = useCurrentRoute();
    const isSignerRoute = currentRoute?.isSignerRoute || false;
    const shouldShowCurtain = location.pathname.startsWith(DASHBOARD_PATH);
    const className = classNames(isSignerRoute ? 'validsign-signer' : 'validsign-v2');
    const curtainClassName = classNames('curtain', {
        'should-show-curtain': shouldShowCurtain
    });
    const shouldShowHeader = !location.pathname.startsWith(LOGIN_PATH)
        && !location.pathname.startsWith(PASSWORD_RECOVERY_PATH)
        && !location.pathname.startsWith(PASSWORD_RESET_PATH)
        && !location.pathname.startsWith(REGISTRATION_PATH)
        && !location.pathname.startsWith(ACCOUNT_REGISTRATION_PATH)
        && !location.pathname.startsWith(ERROR_PATH)
        && !location.pathname.startsWith(FAST_TRACK_PATH)
        && !location.pathname.startsWith(CONNECT_AUTHORIZE_PATH)
        && !location.pathname?.includes(DESIGNER_PATH)
        && !hideHeader;

    return (
        <div className={className}>
            <Helmet htmlAttributes={{lang: locale}}>
                <title>
                    {intl.formatMessage({id: 'page.title', defaultMessage: ''})}
                </title>
            </Helmet>
            <GDPRBunner />
            {!isSignerRoute && <div className={curtainClassName} />}
            {!isSignerRoute && shouldShowHeader && <HeaderV2 />}
            {isSignerRoute && <SignerUiHeader />}
            {isSignerRoute && <SignerUiMenu />}
            {!isSignerRoute && <InfoArticle />}
            <section className="main">
                {children}
            </section>
            <VSFeature feature={VS_FEATURES.FLOATING_MENU}>
                <Enabled>
                    <FloatingActions className={isSignerRoute ? 'signer-ui-floating-actions' : ''} />
                </Enabled>
            </VSFeature>
        </div>
    );
}
